import type {
  ReactElement,
  ReactNode,
} from 'react';
import styled from 'styled-components';
import type {
  TagPresetType,
} from '@n3/css-base';

import { Breadcrumbs } from '../Breadcrumbs';
import type {
  BreadcrumbType,
} from '../Breadcrumbs';
import { PageTitle } from '../PageTitle';
import {
  Tabs,
  renderLinkTab,
} from '../Tabs';
import type {
  TabType,
  TabId,
} from '../Tabs';

const StyledWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingBottom: indents.INDENT_8,
}));

export const StyledParentTitle = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_7,
}));

export const StyledHeaderBlockWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_3,
  marginBottom: indents.INDENT_2,
}));

const StyledTabsWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_1,
  marginBottom: indents.INDENT_4,
}));

export type NestedListLayoutProps = {
  /**
   * Массив объектов хлебных крошек
   */
  breadcrumbs: BreadcrumbType[];
  /**
   * Заголовок родительской сущности
   */
  parentTitle: ReactNode;
  /**
   * Блок действий у заголовка родительской сущности (кнопки и т.п.)
   */
  parentActionsBlock?: ReactNode;
  /**
   * Статус родителя
   */
  parentStatus?: ReactNode;
  /**
   * Цвет тэга статуса родителя
   */
  parentStatusColor?: TagPresetType;
  /**
   * Блок, выводящийся между заголовком страницы и табами
   */
  headerBlock?: ReactNode;
  /**
   * Табы родительской сущности
   */
  tabs: TabType[];
  /**
   * id выбранного таба
   */
  currentTab: TabId;
  /**
   * Заголовок страницы
   */
  title: ReactNode;
  /**
   * Блок действий (кнопки и т.п.)
   */
  actionsBlock?: ReactNode;
  /**
   * Содержимое страницы
   */
  children?: ReactNode;
};

export function NestedListLayout({
  breadcrumbs,
  parentTitle,
  parentActionsBlock = undefined,
  parentStatus = undefined,
  parentStatusColor = undefined,
  headerBlock = undefined,
  tabs,
  currentTab,
  title,
  actionsBlock = undefined,
  children = undefined,
}: NestedListLayoutProps): ReactElement {
  return (
    <StyledWrapper>
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
      />

      <StyledParentTitle>
        <PageTitle
          pageType="parent"
          status={parentStatus}
          statusColor={parentStatusColor}
          actionsBlock={parentActionsBlock}
        >
          {parentTitle}
        </PageTitle>
      </StyledParentTitle>

      {
        headerBlock && (
          <StyledHeaderBlockWrapper>
            {headerBlock}
          </StyledHeaderBlockWrapper>
        )
      }

      <StyledTabsWrapper>
        <Tabs
          tabs={tabs}
          renderTab={renderLinkTab}
          current={currentTab}
        />
      </StyledTabsWrapper>

      <PageTitle
        actionsBlock={actionsBlock}
      >
        {title}
      </PageTitle>

      {children}
    </StyledWrapper>
  );
}
